// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_tax_mode from "../../../../proto/commonapis/gen/buhta_common_v1_tax_mode.js";

const include = Buhta_commonapis__Buhta_common_v1_tax_mode.Buhta.Common.V1.TaxMode;

function toString(param) {
  switch (param) {
    case /* TAX_MODE_UNSPECIFIED */0 :
        return "Не указан";
    case /* TAX_MODE_STANDARD */1 :
        return "Общеустановленный порядок";
    case /* TAX_MODE_KAZ_SNR_PATENT */2 :
        return "Патент";
    case /* TAX_MODE_KAZ_SNR_FIXED */3 :
        return "Фиксированный вычет";
    case /* TAX_MODE_KAZ_SNR_USN */4 :
        return "Упрощенная декларация";
    case /* TAX_MODE_KAZ_SNR_FARMING_LAND */5 :
        return "Для крестьянских или фермерских хозяйств";
    case /* TAX_MODE_KAZ_SNR_FARMING_PRODUCE */6 :
        return "Для производителей сельскохозяйственной продукции";
    case /* TAX_MODE_KAZ_SNR_RETAIL */7 :
        return "Розничный налог";
    case /* TAX_MODE_KAZ_SNR_MOBILE */8 :
        return "Применение специального мобильного приложения";
    
  }
}

const Type_name = include.name;

const Type_to_int = include.to_int;

const Type_from_int = include.from_int;

const Type_from_int_exn = include.from_int_exn;

const Type_to_string = include.to_string;

const Type_from_string_exn = include.from_string_exn;

const Type = {
  name: Type_name,
  to_int: Type_to_int,
  from_int: Type_from_int,
  from_int_exn: Type_from_int_exn,
  to_string: Type_to_string,
  from_string_exn: Type_from_string_exn,
  toString: toString
};

export {
  Type ,
}
/* Buhta_commonapis__Buhta_common_v1_tax_mode Not a pure module */
